import { render } from "./CWarnList.vue?vue&type=template&id=08406f16&scoped=true"
import script from "./CWarnList.vue?vue&type=script&lang=js"
export * from "./CWarnList.vue?vue&type=script&lang=js"

import "./CWarnList.vue?vue&type=style&index=0&id=08406f16&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08406f16"],['__file',"src/views/h5/luqiao/home/sichuanluqiao/CWarnList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08406f16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08406f16', __exports__)) {
    api.reload('08406f16', __exports__)
  }
  
  module.hot.accept("./CWarnList.vue?vue&type=template&id=08406f16&scoped=true", () => {
    api.rerender('08406f16', render)
  })

}


export default __exports__